export default __webpack_public_path__ + "static/media/round-24.187a64b2.svg";